/** @format */

import { query, request } from '@/utils/request';

// 查询支付场景
export const fetchPayScenes = data => {
  return request('/zlb/api/pay/config/query-pay-scenes', {
    method: 'POST',
    data,
  });
};

// 配置页面初始化接口
export const getBusinessConfig = params => {
  return query('/zlb/api/expense/config/init', {
    params,
  });
};

// 获取费用类型配置 api/expense/config/init
export const getNewBusinessConfig2 = params => {
  return query('/zlb/api/expense/config/init-new', {
    params,
  });
};
// 获取费用类型配置 api/expense/config/init
export const getNewBusinessConfig = data => {
  return query('/zlb/api/expense/config/init-list', {
    method: 'POST',
    data,
  });
};

// 配置项修改接口
export const editBusinessConfig = data => {
  return query('/zlb/api/expense/config/edit', {
    method: 'POST',
    data,
  });
};
// 配置项修改接口-新
export const newEditBusinessConfig = data => {
  return query('/zlb/api/expense/config/edit-list', {
    method: 'POST',
    data,
  });
};

// 查询支付场景配置详情
export const fetchPayConfig = data => {
  return request('/zlb/api/pay/config/query-pay-scenes-config', {
    method: 'POST',
    data,
  });
};

// 编辑支付场景配置
export const updataPayConfig = data => {
  return request('/zlb/api/pay/config/save', {
    method: 'POST',
    data,
  });
};
// 存在待支付的数据
export const isExistWaitPayForm = data => {
  return request('/zlb/api/expense/pay/config/is-exist-wait-pay-form', {
    method: 'POST',
    data,
  });
};

// 获取工作台配置（NPS）
export const workbenchConfigurations = () => {
  return request('/api/workbench/configurations', {
    method: 'get',
  });
};

// 获取版式文件缩略图
export const getZlbpFormatUrl = data => {
  return request('/zlb/api/invoice/format-url-thumbnail', {
    method: 'POST',
    data,
  });
};

// 校验收款账户是否有银行行号
export const checkIsExistBankNo = data => {
  return request('/zlb/api/pay/bankCard/supplier/check-is-exist-bankNo', {
    method: 'POST',
    data,
  });
};

// 更新收款账户（供应商）
export const updateSupplierBankCard = data => {
  return request('/zlb/api/pay/bankCard/supplier/update', {
    method: 'POST',
    data,
  });
};

// 获取企业标识
export const getEnterpriseTag = data => {
  return request('/zlb/api/expense/common/enterprise-tag', {
    method: 'POST',
    data: JSON.stringify(data.keyList),
    headers: {
      'content-type': 'application/json;charset=UTF-8',
    },
  });
};

// 查询单位业务配置
export const getOrgExpenseBusinessConfig = data => {
  return query('/zlb/api/expense/common/query/org-business-config', {
    method: 'POST',
    data,
  });
};

// 敏感词匹配
export const sensitiveWordMatch = data => {
  return query('/zlb/api/sop/content-censor/content-sensitive-censor', {
    method: 'POST',
    data,
  });
};
